import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import Label10Font from '../../Theme/Fonts/Label10'

export type TopLabelProps = {
    /** label which is shown at the center of the top border */
    topLabel?: string
    /** margin to the left side */
    marginLeft?: number | string | number[] | string[] | (number | string)[]
    /** marign to the right side */
    marginRight?: number | string | number[] | string[] | (number | string)[]
    /**
     * callback when the top label gets pressed
     * @TJS-type function
     * */
    onPress?: () => void
    /**
     * href for when top label gets pressed
     * */
    href?: string
}

const TopLabel: FC<
    Required<Pick<TopLabelProps, 'topLabel'>> &
        Pick<TopLabelProps, 'marginLeft' | 'marginRight' | 'onPress' | 'href'>
> = ({ topLabel, marginLeft, marginRight, onPress, href }) => (
    <Grid noExpand marginTop={-7}>
        <Touchable onPress={onPress} href={href}>
            <Grid noExpand marginLeft={marginLeft} marginRight={marginRight}>
                <Grid noExpand height={12} marginX="auto" zIndex={2}>
                    <Label10Font lineHeight="12px" color="keshi-3" paddingX={2}>
                        {topLabel}
                    </Label10Font>
                    <Grid noExpand height={1} marginTop={-6} backgroundColor="pearl" zIndex={-1} />
                </Grid>
            </Grid>
        </Touchable>
    </Grid>
)

export default TopLabel
